import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  gridGap: number;
  lineWidth: number;
  gridColor?: string;
  gridOpacity?: number;
  ref?: React.Ref<SVGSVGElement>;
}

function SvgWithGrid({
  gridGap,
  lineWidth,
  gridColor = 'var(--color-gray-500)',
  gridOpacity = 0.3,
  children,
  ref,
  ...props
}: Props) {
  const id = React.useId().replace(/:/g, '');
  const gridId = `${id}-grid`;

  return (
    <svg {...props} ref={ref}>
      <defs>
        <pattern
          id={gridId}
          width={gridGap}
          height={gridGap}
          patternUnits="userSpaceOnUse"
        >
          <path
            d={`
            M ${gridGap} 0 L ${gridGap} ${gridGap}
            M 0 ${gridGap} L ${gridGap} ${gridGap}
          `}
            fill="none"
            stroke={gridColor}
            strokeWidth={lineWidth}
          />
        </pattern>
      </defs>
      <rect
        width="100%"
        height="100%"
        fill={`url(#${gridId})`}
        fillOpacity={gridOpacity}
      />

      {children}
    </svg>
  );
}

export default SvgWithGrid;
